import * as React from 'react';
/**
 *
 * Original name: thumbs down
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A309
 *
 */
export const ThumbsDownPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "m53.033 30.972-2.608-15A5.989 5.989 0 0 0 44.513 11H27.581c-2.125 0-4.21.565-6.046 1.635l-10.658 6.217V38H17.6c.417 0 .824.13 1.163.373l4.9 3.5c.345.246.603.597.734 1L28.436 55h2.75a10 10 0 0 0 9.594-12.822L39.55 38h7.571a6 6 0 0 0 5.911-7.028h.001Zm-4.381 2.315a1.968 1.968 0 0 1-1.53.713H34.2l2.737 9.307A6 6 0 0 1 31.318 51l-3.132-9.4a5.958 5.958 0 0 0-2.205-2.985l-4.9-3.5A5.973 5.973 0 0 0 17.6 34h-2.723V21.148l8.673-5.058A8 8 0 0 1 27.581 15h16.932a2 2 0 0 1 1.971 1.657l2.609 15a1.971 1.971 0 0 1-.441 1.63Z", fill: "currentColor" })));
